import { Resource } from 'react-admin'
import { debug } from '../test'
import { Permissions } from '../types/apiTypes'
import collaborations from './Collaborations'
import notificationConfigurations from './NotificationConfigurations'

const availableResources = ({scopes}: Permissions): JSX.Element[] => [
  <Resource
    key="samenwerkingen"
    name="samenwerkingen"
    options={{
      label: 'Samenwerkingen',
    }}
    list={collaborations.list}
    edit={collaborations.edit}
    show={collaborations.show}
    create={collaborations.create}
    icon={collaborations.icon}
  />,
  <Resource
    key="notification_configuration"
    name="notification_configuration"
    options={{
      label: 'Notificatie configuratie',
    }}
    list={notificationConfigurations.list}
    create={notificationConfigurations.create}
    edit={notificationConfigurations.edit}
    icon={notificationConfigurations.icon}
  />,
]

const fallback = (): JSX.Element[] => [
  <Resource
    key="samenwerkingen"
    name="fallback"
    options={{
      label: 'Samenwerkingen',
    }}
    list={collaborations.list}
    icon={collaborations.icon}
  />
]

export const resourcesForScopes = ({ scopes }: Permissions): JSX.Element[] => {
  debug && console.log({scopes})
  // if (!scopes || scopes.length === 0) {
  //   console.warn('No scopes received, returning fallback resource')
  //   return fallback()
  // }
  const resources = availableResources({ scopes })
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  // .filter(resource => resource.props.options.scopes.find(scope => scopes.includes(scope)) !== undefined)
  if (!resources || resources.length === 0) {
    console.warn('No resources received, returning fallback resource')
    return fallback()
  }
  return resources
}
